import { useState } from "react"

export const useExpansive = (initExpasive?:boolean)=>{
    const [expansive,setExpansive] = useState(initExpasive??false)
 
    const handleChangeState = () =>{
        setExpansive(!expansive)
    }

    const handleSetExpansiveFalse = () =>{
        setExpansive(false)
    }

    const handleSetExpansiveStatus = (status:boolean) =>{
        setExpansive(status)
    }

    return{
        expansive,
        handleChangeState,
        handleSetExpansiveFalse,
        handleSetExpansiveStatus
    }
}